export default function parseCsv(text = "", { maxRows = 500, allowHeaderOnly = false, delimiter = ',', trimValues = true } = {}) {
  const records = [];
  let row = [], value = "", quoted = false;
  const source = String(text).replace(/^\uFEFF/, "");
  const cell = () => trimValues ? value.trim() : value;
  const finishRow = () => { row.push(cell()); if (row.some(Boolean)) records.push(row); row = []; value = ""; };
  for (let index = 0; index < source.length; index++) {
    const character = source[index];
    if (character === '"') {
      if (quoted && source[index + 1] === '"') { value += '"'; index++; }
      else quoted = !quoted;
    } else if (character === delimiter && !quoted) { row.push(cell()); value = ""; }
    else if ((character === "\n" || character === "\r") && !quoted) {
      finishRow();
      if (character === "\r" && source[index + 1] === "\n") index++;
    } else value += character;
  }
  if (quoted) throw new Error("The CSV contains an unclosed quoted field.");
  finishRow();
  if (!records.length || (records.length < 2 && !allowHeaderOnly)) return { headers: [], rows: [] };
  const headers = records.shift();
  const normalized = headers.map(header => header.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, ""));
  if (normalized.some(header => !header) || new Set(normalized).size !== headers.length) throw new Error("CSV column names must be nonempty and unique.");
  if (records.length > maxRows) throw new Error(`Import up to ${maxRows} rows at a time. Split this CSV into smaller files.`);
  return { headers, rows: records.map((values, index) => {
    if (values.length !== headers.length) throw new Error(`CSV row ${index + 2} has ${values.length} fields; expected ${headers.length}.`);
    return Object.fromEntries(headers.map((header, column) => [header, values[column]]));
  }) };
}
